/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Tab_Remove_TitleInputs */



/**
* | output |
* | --- |
* | "Remove media version?" |
*
* @param {Media_Tab_Remove_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_tab_remove_title = /** @type {((inputs?: Media_Tab_Remove_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Tab_Remove_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la version média ?")
	if (locale === "de") return /** @type {LocalizedString} */ ("Medienversion entfernen?")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere la versione multimediale?")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалить медиа-версию?")
	if (locale === "es") return /** @type {LocalizedString} */ ("¿Eliminar la versión multimedia?")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("删除媒体版本？")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メディアバージョンを削除しますか？")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मीडिया संस्करण हटाएँ?")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover versão para mídia?")
	return /** @type {LocalizedString} */ ("Remove media version?")
});